export function getCustomKeyVariable () {
    return {
      customKey: 0
    }
  }

  export function setCustomKeyVariable () {
    return Math.round(Math.random() * 1000)
  }